exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-viewer{background:#000;display:flex;justify-content:center;align-items:center}.video-viewer video{min-width:400px}", ""]);

